"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidUserOwnership = void 0;
const root_1 = require("../../root");
const isValidUserOwnership = (ownership) => {
    return root_1.USER_OWNERSHIPS.includes(ownership);
};
exports.isValidUserOwnership = isValidUserOwnership;
